export const HICHAT_SET_USER = 'HICHAT_SET_USER';
export const HICHAT_RESET = 'HICHAT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
